<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ProgressLines" });
import "tailwindcss/tailwind.css";
import { ProgressLine } from "../index.js";
export let steps = {};
export let current = void 0;
export let mode = "light";
$: currentIndex = current === void 0 ? -1 : Object.keys(steps).indexOf(current);
const getProgress = (index) => {
    if (current === void 0) {
        return 0;
    }
    if (index === currentIndex) {
        return 50;
    }
    if (index < currentIndex) {
        return 100;
    }
    return 0;
};
</script>

{#key current}
    <ul class = 's8-progress-lines'>
        {#each Object.entries(steps) as [ , label ], index }
            <li>
                <ProgressLine progress = { getProgress(index) } { mode } { label } />
            </li>
        {/each}
    </ul>
{/key}

<style>
    ul.s8-progress-lines {
        display: flex;
        -moz-column-gap: 10px;
             column-gap: 10px;
        margin-top: 20px;
        margin-bottom: 40px;
    }

        ul.s8-progress-lines li {
            flex-grow: 1;
        }</style>